import { render, staticRenderFns } from "./FaqBar.vue?vue&type=template&id=c53a0640"
import script from "./FaqBar.vue?vue&type=script&lang=js"
export * from "./FaqBar.vue?vue&type=script&lang=js"
import style0 from "./FaqBar.vue?vue&type=style&index=0&id=c53a0640&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports